import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import { renderRichText } from "../../utils/richTextUtils";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Header({
  apiToken,
  onNavigate,
  screenSize,
  sliderTheme,
  isHeaderVisible
}) {
  const [isAtelierOpen, setIsAtelierOpen] = useState(false);
  const [isContactsOpen, setIsContactsOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCookiesOpen, setIsCookiesOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [atelierTitle, setAtelierTitle] = useState("");
  const [atelierContent, setAtelierContent] = useState([]);
  const [contactTitle, setContactTitle] = useState("");
  const [contactsContent, setContactsContent] = useState({});
  const [cookiesTitle, setCookiesTitle] = useState("");
  const [cookiesContent, setCookiesContent] = useState([]);
  const [privacyTitle, setPrivacyTitle] = useState("");
  const [privacyContent, setPrivacyContent] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  /* const [isHeaderVisible, setIsHeaderVisible] = useState(true); */

  const location = useLocation();

  const overlayRef = useRef(null);

  const translateMenuOpen = "30px";  
  
  

  const toggleAtelier = () => {
    setIsAtelierOpen(!isAtelierOpen);
    setIsContactsOpen(false);
    setIsCookiesOpen(false);
    setIsPrivacyOpen(false);
  };

  const toggleContacts = () => {
    setIsContactsOpen(!isContactsOpen);
    setIsAtelierOpen(false);
    setIsCookiesOpen(false);
    setIsPrivacyOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsContactsOpen(false);
    setIsContactsOpen(false);
    setIsAtelierOpen(false);
    setIsCookiesOpen(false);
    setIsPrivacyOpen(false);
  };

  const toggleCookies = () => {
    if (isCookiesOpen) {
      setIsCookiesOpen(false);
    } else {
      setIsCookiesOpen(true);
      setIsPrivacyOpen(false);
    }
  };

  const togglePrivacy = () => {
    if (isPrivacyOpen) {
      setIsPrivacyOpen(false);
    } else {
      setIsPrivacyOpen(true);
      setIsCookiesOpen(false);
    }
  };

  const handleOverlayClick = () => {
    setIsAtelierOpen(false);
    setIsContactsOpen(false);
    setIsCookiesOpen(false);
    setIsPrivacyOpen(false);
    setIsMenuOpen(false);
    setIsMobileMenuOpen(false);
  };

  const handleLinkClick = (e, path) => {
    e.preventDefault();
    setIsAtelierOpen(false);
    setIsContactsOpen(false);
    setIsCookiesOpen(false);
    setIsPrivacyOpen(false);
    setIsMenuOpen(false);
    setIsMobileMenuOpen(false);
    onNavigate(path);
  };

  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Fetching menu items
        const menuResponse = await fetch(`${API_BASE_URL}/api/menus`, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        });
        const menuData = await menuResponse.json();
        const sortedMenuItems = menuData.data.sort(
          (a, b) => a.attributes.Order - b.attributes.Order
        );
        setMenuItems(sortedMenuItems);

        // Fetching single types
        const atelierResponse = await fetch(
          `${API_BASE_URL}/api/atelier`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        const atelierData = await atelierResponse.json();
        setAtelierContent(atelierData.data.attributes.Content);
        setAtelierTitle(atelierData.data.attributes.Title);

        const contactsResponse = await fetch(
          `${API_BASE_URL}/api/contact`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        const contactsData = await contactsResponse.json();
        setContactsContent(contactsData.data.attributes);
        /* setContactTitle(contactsData.data.attributes.Title); */

        const cookiesResponse = await fetch(
          `${API_BASE_URL}/api/politique-cookie`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        const cookiesData = await cookiesResponse.json();
        setCookiesContent(cookiesData.data.attributes.Content);
        setCookiesTitle(cookiesData.data.attributes.Title);

        const privacyResponse = await fetch(
          `${API_BASE_URL}/api/politique-confidentialite`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        const privacyData = await privacyResponse.json();
        setPrivacyContent(privacyData.data.attributes.Content);
        setPrivacyTitle(privacyData.data.attributes.Title);
      } catch (error) {
        console.error("Error fetching content:", error);
      }
    };

    fetchContent();

    if (overlayRef.current) {
      overlayRef.current.addEventListener("click", handleOverlayClick);
    }

    return () => {
      if (overlayRef.current) {
        overlayRef.current.removeEventListener("click", handleOverlayClick);
      }
    };
  }, [apiToken]);

  return (
    <header
      className={`header ${isHeaderVisible ? "" : "header-hidden"} ${
        isAtelierOpen || isContactsOpen ? "dropdown-open" : ""
      } ${isMobileMenuOpen ? "mobileMenuOpen" : "mobileMenuClose"} ${
        sliderTheme === "Light" ? "themeLight" : "themeDark"
      }`}
    >
      <div
        ref={overlayRef}
        className={`overlay ${isAtelierOpen || isContactsOpen ? "show" : ""}`}
      ></div>
      <div
        className={`header-content ${
          isAtelierOpen || isContactsOpen ? "dropdown-open" : ""
        }`}
      >
        <Link to="/" className="logo" onClick={(e) => handleLinkClick(e, "/")}>
          SEINE DESIGN
        </Link>
        <nav className={`nav-links ${isMenuOpen ? "open" : ""}`}>
          {menuItems.map((item) => (
            <Link
              key={item.id}
              to={`/${item.attributes.Slug}`}
              className={`nav-link ${
                location.pathname === `/${item.attributes.Slug}`
                  ? "pageActive"
                  : ""
              }`} // Aplicar a classe pageActive
              onClick={(e) => handleLinkClick(e, `/${item.attributes.Slug}`)}
            >
              {item.attributes.Title}
            </Link>
          ))}
          <span
            className={`nav-link ${isAtelierOpen ? "open" : ""}`}
            onClick={toggleAtelier}
          >
            {atelierTitle}
          </span>
          <span
            className={`nav-link ${isContactsOpen ? "open" : ""}`}
            onClick={toggleContacts}
            style={
              isAtelierOpen && (screenSize === "large" || screenSize === "full")
                ? { transform: `translateX(${translateMenuOpen})` }
                : {}
            }
          >
            {contactsContent.Title}
          </span>
        </nav>
        <div className="menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className={`dropdown atelier ${isAtelierOpen ? "open" : ""}`}>
        <div className="dropdown-content">
          {atelierContent.length > 0 && renderRichText(atelierContent)}
        </div>
      </div>
      <div
        className={`dropdown contacts ${isContactsOpen ? "open" : ""} ${
          isCookiesOpen || isPrivacyOpen ? "open-policy" : ""
        }`}
      >
        <div className="dropdown-content">
          <p className="email">
            <a href={`mailto: ${contactsContent.Email}`}>
              {contactsContent.Email}
            </a>
          </p>
          <p className="phone">
            <a href={`tel: ${contactsContent.Phone}`}>
              {contactsContent.Phone}
            </a>
          </p>
          <hr></hr>
          <p
            className={`policy-link ${isCookiesOpen ? "open" : ""}`}
            onClick={toggleCookies}
          >
            {cookiesTitle}
          </p>
          <p
            className={`policy-link ${isPrivacyOpen ? "open" : ""}`}
            onClick={togglePrivacy}
          >
            {privacyTitle}
          </p>
          {isCookiesOpen && (
            <div className="policy-content">
              {cookiesContent.length > 0 && renderRichText(cookiesContent)}
            </div>
          )}
          {isPrivacyOpen && (
            <div className="policy-content">
              {privacyContent.length > 0 && renderRichText(privacyContent)}
            </div>
          )}
        </div>
      </div>
      <div className="dropdown-mobile"></div>
    </header>
  );
}
